module.exports = "mutation ($id: ID!, $data: ModelTemplateUpdate!) {\n  ModelTemplateUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"